import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/module_share_open.png'
import _imports_1 from '../../assets/lxhz_icon.png'


const _hoisted_1 = {
  class: "body",
  style: {"margin-top":"0.7rem"}
}
const _hoisted_2 = { class: "body_left" }
const _hoisted_3 = { class: "zs_" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "BL_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "body_right" }
const _hoisted_9 = { class: "BR_body" }
const _hoisted_10 = { class: "BR_body_title" }
const _hoisted_11 = { class: "BR_body_pzsmList" }
const _hoisted_12 = { class: "BR_body_lsfs" }
const _hoisted_13 = { class: "BR_body_lsfs_number" }
const _hoisted_14 = { style: {"text-align":"center","padding-top":"5px","font-size":"20px"} }
const _hoisted_15 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_16 = { class: "zf_body" }
const _hoisted_17 = { class: "zf_body_top" }
const _hoisted_18 = { class: "zf_fs_body" }
const _hoisted_19 = { class: "zf_fs_list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 0,
  class: "zf_fs_icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_23 = { class: "zf_fs_b" }

import { ref, reactive, onMounted } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRoute } from "vue-router";
import { ElMessage, ElTable, ElLoading } from "element-plus";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'moduleImageInformation',
  setup(__props) {

const router = useRoute();
const form = ref({});
document.title = "标识山西-找器材";
const imgzs = ref();
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
//支付金额
let moenyNumber = ref(0);
// 支付组件状态
let payment = ref(false);
let PaymentV = ref('');
let show = ref(true);
// 支付类型列表
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    dh: 'wx',
    img: require("../../assets/lxhz_wx.png"),
    checked: false,
  },
  {
    title: "支付宝",
    dh: 'zfb',
    img: require("../../assets/lxhz_zfb.png"),
    checked: false,
  },
]);
const TwoDimensionalCodeRef = ref<any>();
Axios(
  "get",
  `/material/material/equipment/${router.query.id}`,
  "",
  false,
  function (res) {
    if (res.data.code == 200) {
      // res.data.data.imgss = res.data.data.imgs.filter(
      //   (e) => e.isCoverSheet == 1
      // );
      form.value = res.data.data;
      // console.log(" res.data.data.info", res.data.data.info.createUserId);
      JSON.parse(localStorage.getItem("userList")).memberId ==
        res.data.data.info.createUserId
        ? (show.value = false)
        : (show.value = true);
      document.title += "-" + res.data.data.info.name;
      let list = res.data.data.imgs;
      let list2 = [];
      for (let i = 0; i < list.length; i++) {
        let index = {
          checked: "",
          img: "",
        };
        if (i == 0) {
          index.checked = true;
        } else {
          index.checked = false;
        }
        index.img = list[i].url;
        list2.push(index);
      }
      form.value.imgs = list2;
      // console.log(form.value)
      imgzs.value = form.value.imgs[0].img;
    } else {
      ElMessage.error(res.data.message);
    }
    console.log(form);
    console.log("==========");
  }
);
const imgClick = function (index) {
  imgzs.value = index.img;
  for (let i = 0; i < form.value.imgs.length; i++) {
    if (index == form.value.imgs[i]) {
      form.value.imgs[i].checked = true;
    } else {
      form.value.imgs[i].checked = false;
    }
  }
};
// 获取联系合作 // index 回去对象的的id
let Contact = function () {
  Axios(
    "get",
    "/material/material/equipmentOrder/isPay",
    { id: form.value.info.id },
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data;
    },
    function (res) {
      // ElMessage({
      //   showClose: true,
      //   message: res.data.msg,
      //   type: "warning",
      // });
      // console.log(res.data.data);
      // if(res.data.code !== 500){
      payment.value = true;
      // }
    }
  );
};
//获取金额
let getMoney = function () {
  let url: any;
  if (PaymentV.value == 'wx') {
    url = `/material/material/equipmentOrder/create-pay/WXPAY/${form.value.info.id}`
  } else if (PaymentV.value == 'zfb') {
    url = `/material/material/equipmentOrder/create-pay/ALIPAY/${form.value.info.id}`
  }
  Axios(
    "post",
    url,
    {},
    false,
    function (res) {
      // moenyNumber.value = res.data.msg;

      TwoDimensionalCodeRef.value.init(
        res.data.data.qrcode,
        res.data.data.sceneId,
        form.value.info.id
      );
    }
  );
};
// 支付获取联系方式
let get_sjh = function () {
  Axios(
    "POST",
    "/member/contacts?memberId=" +
    JSON.parse(localStorage.getItem("userList")).memberId,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${JSON.parse(localStorage.getItem("userList")).memberId
        }`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            JSON.parse(localStorage.getItem("userList")).memberId
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/material/material/equipmentOrder/isPay",
    { id: form.value.info.id },
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) { }
  );
};
// 支付类型切换
let paymentTL_click = function (index) {
  PaymentV.value = index.dh
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: imgzs.value }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.imgs, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(item.checked ? 'zs_list zs_listY' : 'zs_list zs_listN'),
            key: index,
            onClick: ($event: any) => (imgClick(item))
          }, [
            _createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_7)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(form.value.info?.name), 1),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "BR_body_pzsm" }, "配置说明", -1)),
        _createElementVNode("div", _hoisted_11, _toDisplayString(form.value.info?.description), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "BR_body_lsfs_title" }, "联系方式", -1)),
        _createElementVNode("p", _hoisted_13, _toDisplayString(form.value.info?.contactInformation), 1)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: PartnersMobileNumber.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((PartnersMobileNumber).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"text-align":"center"} }, "联系方式", -1)),
        _createElementVNode("div", _hoisted_14, _toDisplayString(PartnersMobileNumber1.value), 1),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 确认 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      "show-close": false,
      modelValue: _unref(payment),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(payment) ? (payment).value = $event : payment = $event)),
      "align-center": "",
      width: "4.8rem",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "联系合作", -1)),
            _createElementVNode("img", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false)),
              class: "cur",
              src: _imports_0
            })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "zf_body_title" }, "支付相应费用，获得联系方式", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "zf_b_M" }, [
            _createElementVNode("span", { CLASS: "zf_b_M_title" }, "应付金额："),
            _createElementVNode("span", { class: "zf_b_M_number" }, [
              _createElementVNode("text", { class: "zf_b_M_n_icon" }, "￥"),
              _createTextVNode("9.90")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "zf_fs_title" }, "选择付款方式", -1)),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentTypeList), (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_unref(paymentTL_click)(index))
                }, [
                  _createElementVNode("img", {
                    class: "zf_fs_logo cur",
                    src: index.img
                  }, null, 8, _hoisted_21),
                  _createElementVNode("span", null, _toDisplayString(index.title), 1),
                  (index.checked)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_20))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "zf_fs_b_qx cur",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false))
            }, "取消"),
            _createElementVNode("div", {
              class: "zf_fs_b_qd cur",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(getMoney)()))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(TwoDimensionalCode, {
      ref_key: "TwoDimensionalCodeRef",
      ref: TwoDimensionalCodeRef,
      CloseQrCode: CloseQrCode
    }, null, 512)
  ]))
}
}

})